import { PodForbiddenBody } from '@dev-console/api/errors';

import { ModalShell } from '@/components/modals/modal-shell';

const SLACK_CHANNEL = '#epd-platform-working-team';

export const PodForbiddenModal = ({ detail, onClose }: { detail: PodForbiddenBody; onClose: () => void }) => {
  const userPodsLabel = detail.userPods.length > 0 ? detail.userPods.join(', ') : 'no pods';

  return (
    <ModalShell title='Pod access required' onClose={onClose}>
      <p>
        This action requires the <span className='font-mediumbold text-neutral-900'>{detail.requiredPod}</span> pod.
        You're a member of: <span className='font-mediumbold text-neutral-900'>{userPodsLabel}</span>.
      </p>
      <p className='mt-3 text-neutral-600'>
        If you're the on-call incident lead, joining the{' '}
        <span className='font-mediumbold text-neutral-900'>SG-Eng Incident Lead</span> Okta group grants a cross-pod
        bypass on DLQ actions — log out and back in after joining so a fresh session picks up the new group.
      </p>
      <p className='mt-3 text-neutral-600'>
        Otherwise, reach out in{' '}
        <span className='rounded bg-neutral-100 px-1.5 py-0.5 font-mono text-xs text-neutral-800'>{SLACK_CHANNEL}</span>{' '}
        if you think you should have access.
      </p>
      {detail.canonicalJob && (
        <p className='mt-3 text-xs text-neutral-500'>
          Job: <code className='font-mono'>{detail.canonicalJob}</code>
        </p>
      )}
    </ModalShell>
  );
};
